var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-null"},[_c('van-empty',{attrs:{"image":require('@/assets/station_null.svg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }